import { useContext } from 'react';
import { AuthContext } from './authContext';

export const useAuthInfo = () => {
  const { currentUser, isLoggedIn, isAuthChecking, updateCurrentUser } = useContext(AuthContext);

  return {
    currentUser,
    isLoggedIn,
    isAuthChecking,
    updateCurrentUser,
  };
};
